import { render, staticRenderFns } from "./GestionStockPage.vue?vue&type=template&id=c2a10d84&"
import script from "./GestionStockPage.vue?vue&type=script&lang=js&"
export * from "./GestionStockPage.vue?vue&type=script&lang=js&"
import style0 from "./GestionStockPage.vue?vue&type=style&index=0&id=c2a10d84&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports